import { Box, Button, Typography } from "@mui/material";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";
import React from "react";
import { DayliPlanContext } from "../../../../container/coach/dayliPlan/context/dayliPlanContext";
import IDayliPlan from "../interface/iDayliPlan";

const LoadMoreButton = (): React.JSX.Element => {
  const {
    maxShownAppointments,
    setMaxShownAppointments,
    dayliPlan,
  }: {
    maxShownAppointments: number;
    setMaxShownAppointments: (maxShownAppointments: number) => void;
    dayliPlan: IDayliPlan;
  } = React.useContext(DayliPlanContext);

  return (
    <React.Fragment>
      {maxShownAppointments < dayliPlan.appointments.length && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            mt: 4,
          }}
        >
          <Button
            onClick={() => setMaxShownAppointments(maxShownAppointments + 5)}
            variant="contained"
            color="secondary"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <ArrowDownwardOutlinedIcon />
            <Typography variant="body1" component="div" sx={{ mx: 2 }}>
              Mehr laden
            </Typography>
            <ArrowDownwardOutlinedIcon />
          </Button>
        </Box>
      )}
    </React.Fragment>
  );
};

export default LoadMoreButton;
